<template>
  <div class="flex flex-col flex-1 w-full min-w-0 overflow-hidden">
    <!-- <AppNavBar /> -->
    <AppContainer />
  </div>
</template>

<script>
const AppContainer = () => import('@/components/app/AppContainer')
const AppNavBar = () => import('@/components/app/AppNavBar')

export default {
  name: 'camera',
  components: {
    AppContainer,
    AppNavBar
  },
}
</script>
